<div class="bc-email-widget column-flex-container bc-work-item-theme {{themeClass}}" [attr.data-automation-id]="'bc-email-widget'">
  <work-widget-header class="column-flex-fix bc-panel" *ngIf="isMultiLane && emailThread && lastEmail" [workItem]="workItem" [title]="visitor.fields.name.value || visitor.fields.email.value" [visitor]="visitor"></work-widget-header>

  <div class="bc-layout-wrapper email-widget-content column-flex-grow panel-shadow-wrapper multilane-wrapper" *ngIf="emailThread && lastEmail">
    <div class="column-flex-container multilane-item" [ngClass]="{ 'multilane-item-1': !isExpandedMode(), 'multilane-item-2': isExpandedMode() }">
      <work-widget-header class="column-flex-fix" *ngIf="!isMultiLane" [workItem]="workItem" [title]="visitor.fields.name.value || visitor.fields.email.value"></work-widget-header>

      <app-email-box
        [emailThread]="emailThread"
        [lastEmail]="lastEmail"
        (updateEmail)="loadLastEmailFromThread(emailThread.id)"
        [isCannedMessagePanelOpen]="isCannedMessagePanelOpen"
        [cannedMessageRequest]="cannedMessage"
        [workItemId]="workItem.id"
        [workItemType]="workItem.type" tabindex="-1"></app-email-box>
    </div>

    <div class="bc-work-lane cm-lane-wrapper multilane-item multilane-item-1"
         *ngIf="isEmailThreadActive() && isCannedMessagesLaneVisible">
      <app-canned-message-panel
        [cannedMessageRequest]="cannedMessage"
        [workItemId]="workItem.id"
        [isOpened]="isExpandedMode() || isCannedMessagePanelOpen"
        [isExpanded]="isExpandedMode()"
        [isCannedMessagesTabActive]="isCannedMessagesTabActive"
        [isCustomTabActive]="isCustomTabActive"
      >
      </app-canned-message-panel>
    </div>

    <div *ngIf="isExpandedMode() && isDiscussionsLaneVisible" class="multilane-item multilane-item-1 bc-work-lane discussion-lane-wrapper">
      <app-discussions
        [workItemIsEnded]="!isEmailThreadActive()"
        [workItemId]="workItem.id"
        [workItemType]="workItem.type">
      </app-discussions>
    </div>

    <div class="bc-last-lane multilane-item multilane-item-1" [attr.data-automation-id]="'VISITOR_INFO_PANEL'" *ngIf="isExpandedMode() && isVisitorInfoLaneVisible">
      <div class="bc-panel-maxh">
        <app-compact-visitor-info class="bc-panel" [workItemId]="workItem.id" [visitor]="visitor"></app-compact-visitor-info>
        <app-visitor-history class="bc-panel" *ngIf="emailThread && lastEmail" [emailThreadId]="emailThread.id" [emailId]="lastEmail.id"></app-visitor-history>
      </div>
    </div>
  </div>
  <app-loading *ngIf="!emailThread || !lastEmail" heading="bcLoading.loadingText"></app-loading>
</div>
